RivalIQ.module('views.metric', function (views, App, Backbone, Marionette, $, _) {

    'use strict';

    views.OtherPostsEngagementCell = Marionette.ItemView.extend({
        tagName: 'td',
        className: 'metric-table-cell',
        template: '#engagementLiftTableCellTemplate',

        serializeData: function () {
            const me = this;

            let tipValue = '--';
            const data = me.getOption('data');

            if (_.isNumber(_.last(data))) {
                tipValue = me.model.formatExpanded(data);
            }

            let tooltip;

            if (!_.last(data)) {
                const freeDimension = _.head(me.model.getFreeDimensions());
                if (freeDimension === 'post_tag_id') {
                    const postTagId = _.head(data);
                    const postTag = _.get(me, [
                        'options',
                        'table',
                        'dashboardModel',
                        'postTagsById',
                        postTagId
                    ]);
                    if (postTag) {
                        const channel = me.model.get('channel');
                        const postWord = RivalIQ.data.channels.get(channel).get('postName');
                        tooltip = `All matchings posts include the <strong>${RivalIQ.postTags.utils.postTagHtml(postTag.tag_name)}</strong> tag. Try broadening your search by removing filters or changing dates to see if there are ${postWord}s without this tag.`;
                    }
                }
            }

            if (!tooltip) {
                const tooltipTemplate = Marionette.TemplateCache.get('#tableCellTooltip');
                tooltip = tooltipTemplate({
                    name: me.model.getName(),
                    value: tipValue
                });
            }

            return {
                className: '',
                tooltip: tooltip,
                value: me.model.format(data)
            };
        }
    });

    views.EngagementLiftCell = views.Bar.extend({

        tagName: 'td',
        className: 'metric-table-cell',
        template: '#engagementLiftTableCellTemplate',

        // This metric is a little odd in that 1 is neutral (as opposed to 0). If rawValue is exactly 1, we don't want a class name.
        getValueClassName: function (rawValue) {
            let className;
            if (rawValue > 1) {
                className = 'metric-positive';
            } else if (rawValue < 0) {
                className = 'metric-negative';
            }

            return className;
        },

        getTooltip: function () {
            const me = this;

            const data = me.getOption('data');
            const rawValue = _.last(data) || null;

            let tooltip;
            const freeDimension = _.head(me.model.getFreeDimensions());

            const channel = me.model.get('channel');
            const postWord = RivalIQ.data.channels.get(channel).get('postName');
            let comparison;
            if (rawValue === 1) {
                comparison = 'the same as';
            } else {
                comparison = (rawValue > 1 ? 'better than' : 'worse than');
            }

            switch (freeDimension) {
                case 'post_tag_id': {

                    const postTagId = _.head(data);
                    const postTag = _.get(me, [
                        'options',
                        'table',
                        'dashboardModel',
                        'postTagsById',
                        postTagId
                    ]);
                    let groupName;
                    let withoutName;
                    let companyName;

                    const diffFormatted = `<span class="${me.getValueClassName(rawValue)}">${Math.abs(me.model.format(rawValue))} times</span>`;
                    if (data) {
                        const company = RivalIQ.state.landscape.get('companies').get(data[1]);
                        if (company) {
                            companyName = company.get('name');
                        }
                    }

                    let performanceGroupText;
                    if (postTagId === '__UNTAGGED__') {
                        groupName = '<strong>untagged</strong>';
                        withoutName = 'posts with tags';
                        let fromText = '';
                        if (companyName) {
                            fromText = `from ${companyName}`;
                        } else {
                            fromText = 'within this landscape';
                        }
                        performanceGroupText = `${_.upperFirst(postWord)}s ${fromText} that are ${groupName}`;
                    } else if (postTag) {
                        groupName = `<strong>${RivalIQ.postTags.utils.postTagHtml(postTag.tag_name)}</strong>`;
                        withoutName = `${postWord}s without the ${groupName} tag`;
                        if (companyName) {
                            performanceGroupText = `${_.upperFirst(postWord)}s from ${companyName} tagged with ${groupName}`;
                        } else {
                            performanceGroupText = `${_.upperFirst(postWord)}s within this landscape tagged with ${groupName}`;
                        }
                    }

                    if (!rawValue) {
                        tooltip = `Lift will be calculated if both ${postWord}s with the tag and without the tag have some engagement.`;
                    } else {
                        tooltip = `${performanceGroupText} perform ${diffFormatted} ${comparison} the average engagement rate of ${withoutName}.`;
                    }
                    break;
                }

                case 'hashtag':
                    if (!rawValue) {
                        if (data?.[0] === '__SUMMARY_ROW__') {
                            tooltip = `Lift isn't applicable here because this row represents the average metrics for the query.`;
                        } else {
                            tooltip = `Lift will be calculated if both ${postWord}s with the hashtag and without the hashtag have some engagement.`;
                        }
                    } else {
                        tooltip = `<strong>#${_.head(data)}</strong> ${postWord}s perform <span class="${me.getValueClassName(rawValue)}">${Math.abs(me.model.format(rawValue))} times</span> ${comparison} ${postWord}s without that hashtag.`;
                    }
                    break;

                case 'post':
                    if (!rawValue) {
                        tooltip = `Lift will be calculated if both this ${postWord} and the other ${postWord}s have some engagement.`;
                    } else {
                        tooltip = `This ${postWord} performed <span class="${me.getValueClassName(rawValue)}">${Math.abs(me.model.format(rawValue))} times</span> ${comparison} the other matching ${postWord}s.`;
                    }
                    break;

                case 'keyword':
                    if (!rawValue) {
                        tooltip = `Lift will be calculated if both this ${postWord} and the other ${postWord}s have some engagement.`;
                    } else {
                        const keyword = _.head(data);
                        tooltip = `${_.upperFirst(postWord)}s that include "${keyword}" perform <span class="${me.getValueClassName(rawValue)}">${Math.abs(me.model.format(rawValue))} times</span> ${comparison} ${postWord}s that are not about this topic.`;
                    }
                    break;

                default:
                    if (!rawValue) {
                        tooltip = `Lift will be calculated if both ${postWord}s with the tag and without the tag have some engagement.`;
                    } else {
                        const groupName = _.head(data);
                        const withoutName = `other ${postWord}s`;
                        tooltip = `${groupName} ${postWord}s perform <span class="${me.getValueClassName(rawValue)}">${Math.abs(me.model.format(rawValue))} times</span> ${comparison} the average engagement rate of ${withoutName}.`;
                    }
            }

            return tooltip;
        },

        formatRawValue: function (rawValue, formattedNumber) {
            if (formattedNumber === '--') {
                return formattedNumber;
            }

            return (rawValue < 0 ? `${formattedNumber}x` : `+${formattedNumber}x`);
        },

        serializeData: function () {
            const me = this;

            const data = me.getOption('data');
            const rawValue = _.last(data) || null;
            const formattedValue = me.formatRawValue(rawValue, me.model.format(rawValue));

            return {
                className: me.getValueClassName(rawValue),
                tooltip: me.getTooltip(),
                value: formattedValue,
                partialDataPopover: null
            };
        }
    });
});
